import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	emptyFieldsTooltipState: {
		id: 'polaris-common.idea-card-v2.empty-fields-tooltip-state',
		defaultMessage: 'Fields you select will show up here',
		description: 'Message to show when no fields are selected',
	},
});
